<base-site-layout [heading]="heading | translate" [headerIcon]="icon" [isDialog]="true" (dialogCloseClicked)="close()">
    <iim-card [header]="header">
        <ng-template #header>
            <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
                <h5 class="mb-0">
                    <em class="fas fa-users pe-1"></em>
                    {{ 'Mitarbeiter auswählen' | translate }}
                </h5>
                <span class="text-muted small d-flex align-items-center gap-2">
                    <span>{{ '{{count}} ausgewählt' | translate: { count: selectedMemberCount() } }}</span>
                    @if (inProgress()) {
                        <span class="text-primary">
                            <em class="fas fa-spinner fa-spin pe-1"></em>
                            {{ 'Wird gespeichert…' | translate }}
                        </span>
                    }
                </span>
            </div>
        </ng-template>

        <div class="members-multiselect-container">
            <iim-multiselect
                #multiselect
                [placeholder]="'Mitarbeiter suchen' | translate"
                [formControl]="membersControl"
                [preferences]="multiselectPreferences"
            >
                @for (user of selectableUsers; track user.id) {
                    <iim-autocomplete-option [value]="user">
                        {{ user.valueDisplay }}
                        @if (!user.active) {
                            <span class="text-muted">({{ 'Inaktiv' | translate }})</span>
                        }
                    </iim-autocomplete-option>
                }
            </iim-multiselect>
        </div>
    </iim-card>

    <div class="d-flex justify-content-end align-items-center gap-2 mt-3">
        <button type="button" class="btn btn-primary" (click)="close()" [disabled]="inProgress()">
            <em class="fas fa-check pe-1"></em>
            {{ 'Speichern' | translate }}
        </button>
    </div>
</base-site-layout>
